import React from 'react';
import { useExperimentFlag } from '../../contexts/ExperimentsContext';
import { PromptCard as PromptCardBase } from './PromptCard';
import { PromptCard as PromptCard3 } from './experiments/PromptCard3';
import { PromptCardProps } from './PromptCard.types';

/**
 * Компонент-обертка для выбора между различными версиями PromptCard
 * В зависимости от условий возвращает либо базовую версию, либо экспериментальную
 */
export const PromptCard: React.FC<PromptCardProps> = props => {
    const cardFlag = useExperimentFlag('promptCardRedesign');

    if (cardFlag === 'full_image') {
        return React.createElement(PromptCard3, props);
    }

    return React.createElement(PromptCardBase, props);
};
